import { render, staticRenderFns } from "./ChooseCate.vue?vue&type=template&id=9a5aa240&scoped=true&"
import script from "./ChooseCate.vue?vue&type=script&lang=js&"
export * from "./ChooseCate.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCate.vue?vue&type=style&index=0&id=9a5aa240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5aa240",
  null
  
)

export default component.exports